import React, { Component } from "react";
import { Player, BigPlayButton } from 'video-react';
import "./VideoReactStyles.css";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
let isMounted = false;

const VideoCard = ({title}) => {
    return(
        <div style={{
            padding: 10,
            marginBottom: 20,
            backgroundColor: '#fff',
            borderRadius: 10,
            boxShadow: "2px 1px 5px #ddd",
        }}>
            <Player videoWidth={200}>
                <BigPlayButton position="center" />
                <source src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4" />
            </Player>
            <div style={{
                marginTop: 20,
                paddingLeft: 20
            }}>
                <p>{title}</p>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatum, repudiandae. Sit eaque deleniti aliquid voluptates natus magnam mollitia exercitationem. Nobis!</p>
            </div>
        </div>
    )
}

class UserTutorialsScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            update: false, 
            showAlert: false,
            // categoryDataPrev: this.props.history.location.state.categoryData,
            // serviceDataPrev: this.props.history.location.state.categoryData.categories
            serviceDataByApi: []
        };
    }
    componentDidMount() {
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    render() {
        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        return (
            <div className="tz-2-com tz-2-main h4-padding" style={{}}>
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew 
                                title='Watch Tutorials' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <VideoCard title='Tutorial 1' />
                                <VideoCard title='Tutorial 2' />
                                <VideoCard title='Tutorial 3' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(UserTutorialsScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/UserTutorialsScreenNew.jsx